module.exports = __webpack_public_path__ + "img/img27.2577fe90.svg";